import Cat from "./Assets/Cat.svg";
import BackgroundSVG from "./Assets/Background.svg";
import { Link } from "react-router-dom";
export default function Footer() {
  return (
    <>
      <footer className="w-full relative overflow-hidden">
        <div
          className="min-h-[400px] w-full grid grid-cols-1 md:grid-cols-3 gap-8 items-end px-6 pt-5"
          style={{
            backgroundImage: `url(${BackgroundSVG})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          {/* Grid container for content */}
          <div className="md:col-span-2 grid grid-cols-1 md:place-items-start place-items-center sm:grid-cols-2 gap-8 mb-6 md:gap-12 md:pl-[20%]">
            {/* Socials Section */}
            <div className="text-white">
              <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl mb-6 bottomLine">
                Socials
              </h2>
              <ul className="space-y-4">
                <li>
                  <Link
                    to="https://x.com/overfundedfund"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl hover:text-green-400 transition-colors block"
                  >
                    Twitter
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://t.me/overfundedfund"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl hover:text-green-400 transition-colors block"
                  >
                    Telegram
                  </Link>
                </li>
              </ul>
            </div>

            {/* Discover Section */}
            <div className="text-white">
              <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl mb-6 bottomLine1">
                Discover
              </h2>
              <ul className="space-y-4">
                <li>
                  <Link
                    to="https://liquidlaunch.app/token/0x681AD8f9FBaa8154d1C6B630cA5c3aAD79171939"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl hover:text-green-400 transition-colors block"
                  >
                    Liquid Launch
                  </Link>
                </li>
                {/*<li>
                  <Link
                    to="/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl hover:text-green-400 transition-colors block"
                  >
                    Dexscreener
                  </Link>
                </li>
                <li>
                  <Link
                    to="/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl hover:text-green-400 transition-colors block"
                  >
                    Hyperswap
                  </Link>
                </li>*/}
              </ul>
            </div>
          </div>

          {/* Cat Illustration - positioned at bottom right on md+ screens, centered on smaller screens */}
          <div className="flex justify-end items-end h-full md:mt-[50px]">
            <div className="w-full max-w-[300px] md:max-w-[340px] lg:max-w-[400px]">
              <img
                src={Cat}
                alt="Cute Cat Holding a Sign"
                className="w-full h-auto object-contain"
              />
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
